<template>
  <div class="app">
    <router-view />
  </div>
</template>
<script>
import _debounce from 'lodash/debounce';
export default {
  created() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  methods: {
    handleWindowResize: _debounce(function(e) {
      this.$store.dispatch('setWindowSize', e.target);
    }, 200)
  }
};
</script>
